import React, { useEffect, useState } from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import LinearProgress from '@mui/material/LinearProgress'
import ConvertiblesApi from '../../../api/ConvertiblesApi'
import ConvertiblesGrid from '../../../components/entities/ConvertiblesGrid'
import { ConvertibleEntity } from 'types/ConvertibleEntity'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'

type AdminConvertiblesViewComponent = React.FC

const AdminConvertiblesView: AdminConvertiblesViewComponent = () => {
    const [convertibles, setConvertibles] = useState<ConvertibleEntity[]>([])
    const [filteredConvertibles, setFilteredConvertibles] = useState<ConvertibleEntity[]>([])
    const [includeCompletedConvertibles, setIncludeCompletedConvertibles] = useState(true)
    const convertiblesApi = new ConvertiblesApi()
    const { t } = useTranslation()

    useEffect(() => {
        async function fetchData() {
            const fetchedConvertibles = await convertiblesApi.findAll()
            setConvertibles(fetchedConvertibles)
        }
        void fetchData()
    }, [])

    useEffect(() => {
        const filtered = convertibles.filter((convertible) =>
            includeCompletedConvertibles ? true : !convertible.completed,
        )
        setFilteredConvertibles(filtered)
    }, [convertibles, includeCompletedConvertibles])

    return (
        <>
            <Helmet title={t('entities.convertible.plural')} />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'block',
                }}
            >
                {t('entities.convertible.plural')}
            </Typography>
            <Divider sx={{ my: 6 }} />
            <FormControlLabel
                value='Inkludera genomförda konvertibler'
                control={
                    <Checkbox
                        checked={includeCompletedConvertibles}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setIncludeCompletedConvertibles(event.target.checked)
                        }}
                    />
                }
                label='Inkludera genomförda konvertibler'
                labelPlacement='end'
                sx={{ py: 2 }}
            />
            <Card sx={{ mb: 6 }}>
                <CardContent>
                    {convertibles.length > 0 ? (
                        <ConvertiblesGrid
                            convertibles={filteredConvertibles}
                            fields={['convertibleName', 'maturityDate', 'updatedAt']}
                            pagination
                            pageSizeInitialState={100}
                            pageSizeOptions={[10, 25, 100]}
                            detailsPath={(convertible: ConvertibleEntity) => `/admin/convertibles/${convertible.id}`}
                            sortModel={[
                                { field: 'updatedAt', sort: 'asc' },
                                { field: 'convertibleName', sort: 'desc' },
                            ]}
                        />
                    ) : (
                        <LinearProgress />
                    )}
                </CardContent>
            </Card>
        </>
    )
}

export default AdminConvertiblesView
